import { useContext } from 'react';
import PageContext from '../contexts/pageContext';

export function useLinkBuilder(data) {
  const { templateId, navList, isPreview, isEdit, basePath, isMasterTemplate } =
    useContext(PageContext);
  if (isEdit || !data.isLink) {
    return null;
  }
  if (data?.isExistingLink === false) {
    return data.link;
  }
  if (data?.isExternal) {
    return data.link;
  }
  if (!isPreview) {
    const link = data.link === '/' ? '' : '/' + data.link;
    return basePath ? `//${basePath}${link}` : null;
  }

  // courses in preview: special case
  if (data.link === 'courses') {
    return `//${basePath}/courses`;
  }

  const { pageId } = navList.find((el) => el.slug === data?.link) || {};
  return `//${basePath}?templateId=${templateId}&pageId=${pageId}${
    isMasterTemplate ? '&mld=true' : ''
  }`;
}
